import * as React from 'react';

import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

import Button from 'bundles/internal-ui/components/buttons/Button';
import Card from 'bundles/internal-ui/components/cards/Card';
import TextBox from 'bundles/internal-ui/components/forms/TextBox';

import _t from 'i18n!nls/internal-enterprise';

type State = {
  slug: string;
  errorMessage?: string;
};

const programsAPI = API('/api/enterprisePrograms.v1', { type: 'rest' });
const programCurriculumAPI = API('/api/programCurriculumFileOperations.v1', { type: 'rest' });
class EnterpriseProgramDownload extends React.Component<State> {
  state = {
    slug: '',
    errorMessage: null,
  };

  handleUpdateText = (event: React.ChangeEvent<any>) => {
    this.setState({ slug: event.target.value });
  };

  onInputKeyPress = (event: React.KeyboardEvent<any>) => {
    if (event.key === 'Enter') {
      this.onDownloadProgramCurriculum();
    }
  };

  onDownloadProgramCurriculum = () => {
    const { slug } = this.state;
    const uri = new URI().addQueryParam('q', 'slug').addQueryParam('slug', slug);

    Q(programsAPI.get(uri.toString()))
      .then((res) => {
        const programId = (((res || {}).elements || [])[0] || {}).id;
        this.getCurriculumByProgramId(programId);
      })
      .fail((err) => {
        let errorMessage = '';
        if (err.status === 404) {
          errorMessage = _t('Program not found');
        } else {
          errorMessage = err.responseJSON.message;
        }
        this.setState({ errorMessage });
      });
  };

  getCurriculumByProgramId = (programId: string) => {
    const uri = new URI().addQueryParam('action', 'processExport').addQueryParam('programId', programId);
    Q(programCurriculumAPI.post(uri.toString()))
      .then((res) => {
        const csvURL = (res || {}).fileUrl;
        window.open(csvURL);
        this.setState({ errorMessage: '' });
      })
      .fail((err) => {
        const errorMessage = err.responseJSON.message;
        this.setState({ errorMessage });
      });
  };

  render() {
    const { errorMessage, slug } = this.state;
    return (
      <div className="rc-EnterpriseToolsHome">
        <Card>
          <h3>{_t('Download the curriculum from a program')}</h3>
          <TextBox
            placeholder={_t('Program Slug')}
            onUpdateField={this.handleUpdateText}
            currentValue={slug}
            inputProps={{ onKeyPress: this.onInputKeyPress, autoFocus: true }}
          />
          <br />
          <Button text={_t('Download curriculum')} btnStyle="info" onClick={this.onDownloadProgramCurriculum} />
          {errorMessage && (
            <div>
              <br />
              <pre style={{ whiteSpace: 'pre-wrap' }}>{errorMessage}</pre>
            </div>
          )}
        </Card>
      </div>
    );
  }
}

export default EnterpriseProgramDownload;
